
import {
  Component,
  computed,
  inject,
  Input,
  OnDestroy
} from '@angular/core';
import { Subject } from 'rxjs';
import {
  CheckpointGroupService,
  CheckpointService,
  SortDto
} from '@artemis-software/wr-api';
import { catalogTenantId } from '@/utils/admin-utils';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { watch } from '@/utils/signals/watch';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-checkpoint-dialog',
  templateUrl: './checkpoint-dialog.component.html',
  styleUrls: ['./checkpoint-dialog.component.scss'],
})
export class CheckpointDialogComponent implements OnDestroy {

  readonly tenantId = catalogTenantId();

  readonly checkpointGroupService = inject(CheckpointGroupService);
  readonly checkpointService = inject(CheckpointService);

  readonly checkpointGroups = asyncComputed(() => {
    if(!this.tenantId()) {
      return [];
    }
    return this.checkpointGroupService.findAll({
      tenantId: this.tenantId(),
      sort: { sort: 'number', order: SortDto.OrderEnum.Asc }
    });
  });

  readonly checkpoints = asyncComputed(() => {
    if(!this.tenantId()) {
      return [];
    }
    return this.checkpointService.findAll({
      tenantId: this.tenantId(),
      checkpointGroupId: this.selectedCheckpointGroupId || undefined,
      deprecated: false,
      sort: { sort: 'number', order: SortDto.OrderEnum.Asc }
    });
  });

  @Input()
  @Tracked()
  selectedCheckpointGroupId: string | undefined = undefined;

  @Tracked()
  selectedCheckpointId?: string = undefined;

  destroy$: Subject<boolean> = new Subject<boolean>();

  onSubmit = () => this.selectedCheckpointId;

  readonly disableSubmit = computed(() => {
    return this.selectedCheckpointId === undefined;
  });

  onGroupChange(): void {
    this.selectedCheckpointId = undefined;
  }

  constructor() {
    watch(this.checkpointGroups, groups => {
      if(groups && this.selectedCheckpointGroupId === undefined) {
        this.selectedCheckpointGroupId = groups[0].id;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
